<div class="api-page">

  <div class="page-header">
    <div class="page-title">
      <svg class="page-title__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 1.5C12.0221 1.5 9 4.52208 9 8.25C9 8.64372 9.03379 9.03016 9.0988 9.40639C9.16599 9.79527 9.06678 10.1226 8.87767 10.3117L2.37868 16.8107C1.81607 17.3733 1.5 18.1363 1.5 18.932V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H6C6.41421 22.5 6.75 22.1642 6.75 21.75V20.25H8.25C8.66421 20.25 9 19.9142 9 19.5V18H10.5C10.6989 18 10.8897 17.921 11.0303 17.7803L13.6883 15.1223C13.8774 14.9332 14.2047 14.834 14.5936 14.9012C14.9698 14.9662 15.3563 15 15.75 15C19.4779 15 22.5 11.9779 22.5 8.25C22.5 4.52208 19.4779 1.5 15.75 1.5ZM15.75 4.5C15.3358 4.5 15 4.83579 15 5.25C15 5.66421 15.3358 6 15.75 6C16.9926 6 18 7.00736 18 8.25C18 8.66421 18.3358 9 18.75 9C19.1642 9 19.5 8.66421 19.5 8.25C19.5 6.17893 17.8211 4.5 15.75 4.5Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">API Keys</h1>
    </div>
    <p class="page-title__sub">Use these keys to authenticate your API requests. Never expose them in client-side code.</p>
  </div>

  <div class="api-card">
    <div class="api-card__header">
      <span class="api-card__title">Your API keys</span>
      <button type="button" class="btn--primary api-card__create" (click)="createModal.open('1')">Create new key</button>
    </div>
    <div class="key-list" *ngIf="activeKeys.length; else noActiveKeys">
      <ng-container *ngFor="let key of activeKeys" [ngTemplateOutlet]="keyCard" [ngTemplateOutletContext]="{ key: key }"></ng-container>
    </div>
    <ng-template #noActiveKeys>
      <p class="billing-card__desc" style="padding: 24px;">No active keys yet.</p>
    </ng-template>
  </div>

  <div class="api-card" *ngIf="revokedKeys.length">
    <div class="api-card__header">
      <span class="api-card__title">Revoked keys</span>
    </div>
    <div class="key-list">
      <ng-container *ngFor="let key of revokedKeys" [ngTemplateOutlet]="keyCard" [ngTemplateOutletContext]="{ key: key }"></ng-container>
    </div>
  </div>

  <!-- Phones: the create action leaves the card for a bar pinned to the
       bottom of the screen (the header button is hidden there). -->
  <div class="api-page__create-bar">
    <button type="button" class="btn--primary" (click)="createModal.open('1')">Create new key</button>
  </div>

</div>

<ng-template #keyCard let-key="key">
  <div class="key-card">

    <div class="key-card__top">
      <span class="key-card__name">{{ key.name || 'Untitled key' }}</span>
      <span class="key-row__status" [class.key-row__status--revoked]="!key.isActive">
        {{ key.isActive ? 'Active' : 'Revoked' }}
      </span>
    </div>

    <div class="key-secret">
      <span class="key-secret__value">
        {{ isRevealing(key) ? 'Loading…' : (isRevealed(key) ? displayValue(key) : '••••••••••••••••••••••••') }}
      </span>

      <button
        class="key-secret__toggle"
        type="button"
        [disabled]="isRevealing(key)"
        [attr.aria-label]="isRevealed(key) ? 'Hide key' : 'Show key'"
        (click)="toggleReveal(key)"
      >
        <svg *ngIf="!isRevealed(key)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <svg *ngIf="isRevealed(key)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
        </svg>
      </button>

      <button
        class="key-secret__toggle"
        type="button"
        *ngIf="isRevealed(key)"
        [attr.aria-label]="isCopied(key) ? 'Copied' : 'Copy key'"
        (click)="copyValue(key)"
      >
        <svg *ngIf="!isCopied(key)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5 6.5C5 5.67157 5.67157 5 6.5 5H12.5C13.3284 5 14 5.67157 14 6.5V12.5C14 13.3284 13.3284 14 12.5 14H6.5C5.67157 14 5 13.3284 5 12.5V6.5Z" fill="currentColor"/>
          <path d="M3.5 2C2.67157 2 2 2.67157 2 3.5V9.5C2 10.3284 2.67157 11 3.5 11L3.5 6.5C3.5 4.84315 4.84315 3.5 6.5 3.5H11C11 2.67157 10.3284 2 9.5 2H3.5Z" fill="currentColor"/>
        </svg>
        <svg *ngIf="isCopied(key)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7803 4.21967C14.0732 4.51256 14.0732 4.98744 13.7803 5.28033L6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303L2.21967 9.28033C1.92678 8.98744 1.92678 8.51256 2.21967 8.21967C2.51256 7.92678 2.98744 7.92678 3.28033 8.21967L6 10.9393L12.7197 4.21967C13.0126 3.92678 13.4874 3.92678 13.7803 4.21967Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <div class="key-card__bottom">
      <span class="key-row__date">Created {{ key.createdAt | date:'mediumDate' }}</span>
      <button class="btn--revoke" *ngIf="key.isActive" (click)="revoke(key)">Revoke</button>
      <button class="btn--revoke" *ngIf="!key.isActive" (click)="delete(key)">Delete</button>
    </div>

  </div>
</ng-template>
